import { render, staticRenderFns } from "./chateau-leoville-las-cases.vue?vue&type=template&id=2d616e32&scoped=true"
import script from "./chateau-leoville-las-cases.vue?vue&type=script&lang=js"
export * from "./chateau-leoville-las-cases.vue?vue&type=script&lang=js"
import style0 from "./chateau-leoville-las-cases.vue?vue&type=style&index=0&id=2d616e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d616e32",
  null
  
)

export default component.exports